import { type IAnalyticEventsConfig } from "@magnit/analytic-events/src/manager";

export const modalAdultEvents: IAnalyticEventsConfig = {
  "ModalAdult:View": {
    ya: {
      eventName: "askAge_view",
      block: "askAge",
      page: "",
    },
  },
  "ModalAdult:Click:Yes": {
    ya: {
      eventName: "askAge_yes_click",
      block: "askAge",
      page: "",
      element: "yes",
    },
  },
  "ModalAdult:Click:No": {
    ya: {
      eventName: "askAge_no_click",
      block: "askAge",
      page: "",
      element: "no",
    },
  },
};
